<template>
  <div>
    <div ref="myDiagramDIV" :style="{ width: 100 + '%', height: clientHeight - 200 + 'px' }"></div>
    <div ref="myOverviewDiv" style="width:200px; height:200px; position:absolute; top:50px; left:50px;"></div>
  </div>
</template>

<script>
import store from '@store'
import gojs from 'gojs'

let $ = gojs.GraphObject.make

export default {
  store,
  name: '',
  props: ['modelData'],
  data () {
    return {
      diagram: null,
    }
  },
  mounted () {
    console.log(this.clientHeight)
    let myDiagram =
      $(window.go.Diagram, this.$refs.myDiagramDIV,
        {
          // initialContentAlignment: window.go.Spot.Center,
          // 树形图布局
          // layout: $(window.go.TreeLayout, {angle: 90, arrangement: window.go.TreeLayout.ArrangementHorizontal}),
          'toolManager.hoverDelay': 500,
        })
    myDiagram.nodeTemplate =
      $(window.go.Node, 'Auto',
        new window.go.Binding('location', 'loc', window.go.Point.parse).makeTwoWay(window.go.Point.stringify),
        // new window.go.Binding('location', 'loc'),
        {
          locationSpot: window.go.Spot.Center,
          toEndSegmentLength: 30,
          fromEndSegmentLength: 30,
        },
        $(window.go.Shape, 'RoundedRectangle', // 节点形状
          {
            parameter1: 20,
            fill: $(window.go.Brush, 'Linear', {0.0: 'lightskyblue', 1.0: 'Lavender'}),
            stroke: null,
            portId: '',
            // fromLinkable: true,
            // fromLinkableSelfNode: true,
            // fromLinkableDuplicates: true,
            // toLinkable: true,
            // toLinkableSelfNode: true,
            // toLinkableDuplicates: true,
            cursor: 'pointer',
          }),
        // {fill: $(window.go.Brush, 'Linear', {0.0: 'lightskyblue', 1.0: 'Lavender'})}), // 颜色
        $(window.go.TextBlock, // 文本周围的margin
          {margin: 8},
          new window.go.Binding('text').makeTwoWay()), // 文字
        {
          toolTip:
            $('ToolTip',
              $(window.go.TextBlock, {margin: 4},
                new window.go.Binding('text', 'tooltip')),
            ),
        },
      )

    myDiagram.linkTemplate =
      $(window.go.Link,
        {
          // routing: window.go.Link.Normal,
          curve: window.go.Link.Bezier,
          toShortLength: 3,
        },
        new window.go.Binding('points').makeTwoWay(),
        new window.go.Binding('curviness'),
        $(window.go.Shape, new window.go.Binding('stroke', 'color')),
        $(window.go.Shape, {toArrow: 'Standard'}), // 箭头
        {
          selectionAdornmentTemplate:
            $(window.go.Adornment,
              $(window.go.Shape,
                {isPanelMain: true, stroke: 'lightskyblue', strokeWidth: 2}),
              $(window.go.Shape,
                {toArrow: 'Standard', fill: 'lightskyblue', stroke: null}),
            ),
        },
        $(window.go.Panel, 'Auto', // option以及线中间擦除
          $(window.go.Shape, 'Diamond', {fill: 'lightskyblue', stroke: 'gray'}),
          // $(window.go.Shape,
          //   {
          //     fill: $(window.go.Brush, 'Radial',
          //       {0: 'rgb(255, 255, 255)', 0.3: 'rgb(255, 255, 255)', 1: 'rgb(255, 255, 255, 0)'}),
          //     stroke: null,
          //   }),
          $(window.go.TextBlock, new window.go.Binding('text', 'text'),
            new window.go.Binding('visible', 'isSelected').ofObject(),
            {
              textAlign: 'center',
              margin: 4,
            },
            new window.go.Binding('text').makeTwoWay(),
          ),
        ),
      )
    $(window.go.Overview, this.$refs.myOverviewDiv,
      {observed: myDiagram, contentAlignment: window.go.Spot.Center})
    this.diagram = myDiagram
    this.updateModel(this.modelData)
  },
  watch: {
    modelData: function (val) {
      this.updateModel(val)
    },
  },
  computed: {
    ...Vuex.mapState({
      clientHeight: state => state.clientHeight,
    }),
  },
  methods: {
    model: function () {
      return this.diagram.model
    },
    updateModel: function (val) {
      // No GoJS transaction permitted when replacing Diagram.model.
      if (val instanceof window.go.Model) {
        this.diagram.model = val
      } else {
        let m = new window.go.GraphLinksModel()
        if (val) {
          for (let p in val) {
            m[p] = val[p]
          }
        }
        this.diagram.model = m
      }
    },
    updateDiagramFromData: function () {
      this.diagram.startTransaction()
      // This is very general but very inefficient.
      // It would be better to modify the diagramData data by calling
      // Model.setDataProperty or Model.addNodeData, et al.
      this.diagram.updateAllRelationshipsFromData()
      this.diagram.updateAllTargetBindings()
      this.diagram.commitTransaction('updated')
    },
    makeAImage: function () {
      let img = this.diagram.makeImage({
        background: 'white',
        type: 'image/jpeg',
        maxSize: new window.go.Size(Infinity, Infinity),
      })
      // console.log(img)
      let alink = document.createElement('a')
      alink.href = img.src
      alink.download = 'template'
      alink.click()
      // console.log(this.diagram.viewportBounds)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/question-editor/components/question-tree-box/src/diagram.vue